import api from './api';

const BASE = '/benachrichtigungen';

export interface EventDefinition {
  id: string;
  label: string;
  category: string;
  required_permissions?: string[];
  implemented?: boolean;
}

export interface ListEventsParams {
  filter_by_role?: boolean;
  filter_for_mitarbeiter?: number;
  only_implemented?: boolean;
}

export interface BenachrichtigungenResponse {
  events_email: string[];
  events_gotify: string[];
  events_inapp: string[];
  schwachstellen_nur_betroffene: boolean;
  effective_events_email: string[];
  effective_events_gotify: string[];
  effective_events_inapp: string[];
  gotify_configured: boolean;
  admin_override_active: boolean;
}

export interface BenachrichtigungenUpdateSelf {
  events_email?: string[];
  events_gotify?: string[];
  events_inapp?: string[];
  schwachstellen_nur_betroffene?: boolean;
}

export type GotifyDeliveryMode = 'send' | 'allowlist' | 'suppress';

export interface GlobalGotifyUrlResponse {
  gotify_base_url_stored: string | null;
  gotify_base_url_env: string | null;
  app_env: string;
  gotify_delivery_mode: string;
  gotify_delivery_mode_environment: string;
  gotify_delivery_mode_in_database: boolean;
}

export type GlobalGotifyUrlUpdate = {
  gotify_base_url?: string | null;
  gotify_delivery_mode?: GotifyDeliveryMode | null;
};

export interface BenachrichtigungenAdminResponse {
  mitarbeiter_id: number;
  gotify_token_set: boolean;
  gotify_url: string | null;
  gotify_url_effective: string | null;
  gotify_url_from_env: boolean;
  gotify_url_from_app_settings: boolean;
  events_email: string[];
  events_gotify: string[];
  events_inapp: string[];
  schwachstellen_nur_betroffene: boolean;
  admin_override_events_email: string[] | null;
  admin_override_events_gotify: string[] | null;
  admin_override_events_inapp: string[] | null;
}

export interface BenachrichtigungenUpdateAdmin {
  gotify_token?: string;
  gotify_url?: string;
  admin_override_events_email?: string[] | null;
  admin_override_events_gotify?: string[] | null;
  admin_override_events_inapp?: string[] | null;
  reset_override?: boolean;
}

export const benachrichtigungenService = {
  listEvents: (params?: ListEventsParams): Promise<EventDefinition[]> => {
    const searchParams = new URLSearchParams();
    if (params?.filter_by_role) searchParams.set('filter_by_role', '1');
    if (params?.filter_for_mitarbeiter != null) searchParams.set('filter_for_mitarbeiter', String(params.filter_for_mitarbeiter));
    if (params?.only_implemented === false) searchParams.set('only_implemented', '0');
    const qs = searchParams.toString();
    return api.get(`${BASE}/events${qs ? `?${qs}` : ''}`).then((r) => r.data);
  },

  getOwn: (): Promise<BenachrichtigungenResponse> =>
    api.get(`${BASE}/me`).then((r) => r.data),

  updateOwn: (data: BenachrichtigungenUpdateSelf): Promise<BenachrichtigungenResponse> =>
    api.put(`${BASE}/me`, data).then((r) => r.data),

  getByMitarbeiter: (mitarbeiterId: number): Promise<BenachrichtigungenAdminResponse> =>
    api.get(`${BASE}/mitarbeiter/${mitarbeiterId}`).then((r) => r.data),

  updateByMitarbeiter: (
    mitarbeiterId: number,
    data: BenachrichtigungenUpdateAdmin
  ): Promise<BenachrichtigungenAdminResponse> =>
    api.put(`${BASE}/mitarbeiter/${mitarbeiterId}`, data).then((r) => r.data),

  getMitarbeiterWithGotify: (): Promise<{ id: number; vorname: string; nachname: string }[]> =>
    api.get(`${BASE}/mitarbeiter-gotify`).then((r) => r.data),

  sendPush: (data: {
    mitarbeiter_ids: number[];
    title: string;
    message: string;
  }): Promise<{
    gesendet: number;
    fehlgeschlagen: number;
    uebersprungen: number;
    uebersprungen_ohne_gotify_konfiguration: number;
    uebersprungen_versand_unterdrueckt: number;
  }> =>
    api.post(`${BASE}/push`, data).then((r) => r.data),

  getGlobalGotifyUrl: (): Promise<GlobalGotifyUrlResponse> =>
    api.get(`${BASE}/admin/global-gotify-url`).then((r) => r.data),

  putGlobalGotifyUrl: (data: GlobalGotifyUrlUpdate): Promise<GlobalGotifyUrlResponse> =>
    api.put(`${BASE}/admin/global-gotify-url`, data).then((r) => r.data),
};
